module.exports = __webpack_public_path__ + "static/media/miysis_3d_cdcl_domaine_petit_parc_residence-vue_1_finale.066b9251.jpg";